import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const Profile = () => {
  const { user, loading, token } = useAuth();
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [isEditing, setIsEditing] = useState(false);

  // Load user data into form
  useEffect(() => {
    if (user) {
      setFormData(prevState => ({
        ...prevState,
        full_name: user.full_name || '',
        email: user.email || ''
      }));
    }
  }, [user]);

  const { full_name, email, currentPassword, newPassword, confirmPassword } = formData;

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const toggleEdit = () => {
    setIsEditing(!isEditing);
    // Reset password fields and message when toggling edit mode
    setFormData({
      ...formData,
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setMessage({ type: '', text: '' });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    // Validate form
    if (isEditing && newPassword) {
      if (!currentPassword) {
        setMessage({ type: 'error', text: 'Current password is required to change password' });
        return;
      }
      if (newPassword !== confirmPassword) {
        setMessage({ type: 'error', text: 'New passwords do not match' });
        return;
      }
      if (newPassword.length < 6) {
        setMessage({ type: 'error', text: 'Password must be at least 6 characters' });
        return;
      }
    }

    try {
      // Prepare update data
      const updateData = {
        full_name
      };

      // Include password change if provided
      if (newPassword) {
        updateData.currentPassword = currentPassword;
        updateData.newPassword = newPassword;
      }

      // Send update request
      await axios.put('/api/users/profile', updateData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      setMessage({ type: 'success', text: 'Profile updated successfully' });
      setIsEditing(false);
    } catch (err) {
      setMessage({
        type: 'error',
        text: err.response?.data?.error || 'Error updating profile'
      });
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="profile-container">
      <h2>User Profile</h2>
      {message.text && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Full Name:</label>
          <input
            type="text"
            name="full_name"
            value={full_name}
            onChange={handleChange}
            disabled={!isEditing}
            required
          />
        </div>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={email}
            disabled={true} // Email cannot be changed
            required
          />
        </div>

        {isEditing && (
          <>
            <h3>Change Password (Optional)</h3>
            <div className="form-group">
              <label>Current Password:</label>
              <input
                type="password"
                name="currentPassword"
                value={currentPassword}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>New Password:</label>
              <input
                type="password"
                name="newPassword"
                value={newPassword}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Confirm New Password:</label>
              <input
                type="password"
                name="confirmPassword"
                value={confirmPassword}
                onChange={handleChange}
              />
            </div>
          </>
        )}

        <div className="button-group">
          {isEditing ? (
            <>
              <button type="submit" className="save-btn">
                Save Changes
              </button>
              <button
                type="button"
                className="cancel-btn"
                onClick={toggleEdit}
              >
                Cancel
              </button>
            </>
          ) : (
            <button type="button" className="edit-btn" onClick={toggleEdit}>
              Edit Profile
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Profile;
